@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.rate {
  display: inline-grid;
  grid-template-columns: auto 1fr 1fr;
  place-items: center;
}

.amount {
  line-height: 20px;
  font-size: 20px;
  font-weight: 600;
  color: @orders-drawer--rate-and-create--amount--text-color;
  margin-top: 4px;
}

.warning {
  color: @orders-drawer--rate-and-create--warning--text-color;
  font-size: 12px;

  svg {
    fill: @orders-drawer--rate-and-create--warning--fill-color;
    padding: 6px;
  }
}

.rate-and-create-container {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  background-color: @orders-drawer--rate-and-create--background-color;
  box-shadow: 1px 3px 2px @orders-drawer--rate-and-create--box-shadow-color;
  margin-bottom: 2px;
  padding: 10px 5px;
}

.rate-and-create {
  place-items: center center;
  display: grid;
  grid-template-columns: auto 1fr 225px;
  justify-content: space-between;
  [class*='create-and-print-label-button'] {
    margin-left: 5px;
  }
}

.repeat-get-rates {
  height: 30px;
  fill: @orders-drawer--default--fill-color;
  cursor: pointer;
  padding: 7px;
  &:hover {
    fill: @orders-drawer--default--hover--fill-color;
  }
}
